var _defs, _namedview;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgOpacity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 38,
    width: 32,
    id: "svg865",
    docname: "opacity.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs869"
  })), _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    pageopacity: 0,
    pageshadow: 2,
    "window-width": 1866,
    "window-height": 1052,
    id: "namedview867",
    showgrid: "false",
    "fit-margin-top": 0,
    "fit-margin-left": 0,
    "fit-margin-right": 0,
    "fit-margin-bottom": 0,
    zoom: 17.291667,
    cx: 16,
    cy: 18,
    "window-x": 54,
    "window-y": 0,
    "window-maximized": 1,
    "current-layer": "svg865"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g895",
    transform: "translate(-8,-4)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 12.509777,
    rx: 14.215801,
    cy: 24.318071,
    cx: 23.942167,
    id: "path875",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 9.10612583,
      strokeOpacity: 0.18518521
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 8.0278492,
    rx: 4.9627895,
    cy: 15.527711,
    cx: 23.826508,
    id: "path875-3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.31008387,
      strokeOpacity: 0.18518521
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64b5f6",
      fillOpacity: 1
    },
    id: "path863",
    d: "M 24,42 Q 17.35,42 12.675,37.475 8,32.95 8,26.3 8,23 9.275,20.15 10.55,17.3 12.75,15.1 L 24,4 35.25,15.1 q 2.2,2.2 3.475,5.05 Q 40,23 40,26.3 40,32.95 35.325,37.475 30.65,42 24,42 Z M 11.15,28 h 25.7 Q 37.5,24.55 36.1,21.65 34.7,18.75 33.3,17.4 L 24,8.25 14.7,17.4 q -1.4,1.35 -2.8,4.25 -1.4,2.9 -0.75,6.35 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpacity);
export default __webpack_public_path__ + "static/media/opacity.b0a76c842b4b68e5225978dc7450ebb6.svg";
export { ForwardRef as ReactComponent };